import { Alert, AlertTitle, Box } from '@mui/material'
import { QuantificationUnit, QUProposedMatch } from '../../types/apiModels'

type PaddockRef = { id: string; name?: string }

type ExcessHectaresWarningProps = {
  proposedMatches: QUProposedMatch[]
  quantificationUnits?: QuantificationUnit[]
  paddocks?: PaddockRef[]
}

const ExcessHectaresWarning = ({
  proposedMatches,
  quantificationUnits = [],
  paddocks = [],
}: ExcessHectaresWarningProps) => {
  const matchesWithExcess = proposedMatches.filter(m => m.excessHectares > 0)

  if (!matchesWithExcess.length) return null

  const quColorById = new Map(quantificationUnits.map(qu => [qu.id, qu.color]))
  const paddockNameById = new Map(paddocks.map(p => [p.id, p.name]))

  return (
    <Alert severity="warning" sx={{ mb: 1 }}>
      <AlertTitle>Exceso de hectáreas detectado</AlertTitle>
      {matchesWithExcess.map(match => {
        const color = quColorById.get(match.quId)
        const paddockName = paddockNameById.get(match.paddockId) ?? match.paddockId

        return (
          <Box
            key={`${match.quId}-${match.paddockId}`}
            sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}
          >
            {color && (
              <Box
                aria-label="Color de la unidad de cuantificación"
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: '2px',
                  backgroundColor: color,
                  border: '1px solid rgba(0,0,0,0.2)',
                  flexShrink: 0,
                }}
              />
            )}
            <span>
              {match.excessHectares.toFixed(1)} ha del lote <strong>{paddockName}</strong> están
              fuera de la unidad de cuantificación. Este área se descarta.
            </span>
          </Box>
        )
      })}
    </Alert>
  )
}

export default ExcessHectaresWarning
